<template>
    <v-app>
        <v-app-bar
            border
        >
        <v-app-bar-nav-icon @click="rail = !rail"></v-app-bar-nav-icon>
        <div class="d-flex align-center">
          <v-img
            alt="Alison Logo"
            class="shrink mr-2"
            :src="alisonLogo"
            transition="scale-transition"
            width="40"
          />
          <h2>TestPanel: v{{botonera_version}}</h2>
        </div>

        <v-spacer></v-spacer>
        <div>AlisonJS: v{{alisonJS_version}}  |  AlisonGUI: v{{alisonGUI_version}}</div>
        <v-spacer></v-spacer>

        <v-btn
          @click="toggleView"
          text
          class="mr-2"
        >
          <span class="mr-2">{{ showIframe ? 'Show Normal View' : 'Show in iFrame' }}</span>
          <v-icon>mdi-{{ showIframe ? 'application' : 'application-braces' }}</v-icon>
        </v-btn>

        <v-btn
          v-if="showIframe"
          @click="reloadIframe"
          text
          class="mr-2"
        >
          <span class="mr-2">Relaunch iFrame</span>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <v-btn
          href="https://certisur.atlassian.net/wiki/spaces/ASP/pages/1146992/Alison+JS"
          target="_blank"
          text
        >
          <span class="mr-2">docs & download</span>
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </v-app-bar>

      <v-navigation-drawer v-model:rail="rail" permanent>
        <v-list density="compact" nav v-model:opened="openedGroups">
          <template v-for="menu in menuArray" :key="menu.name">
            <v-list-group v-if="menu.pages" :value="menu.name">
              <template v-slot:activator="{ props }">
                <v-list-item
                  v-bind="props"
                  :prepend-icon="menu.icon"
                  :title="menu.name"
                  :disabled="menu.disabled"
                >
                  <v-tooltip activator="parent" location="end">{{ menu.name }}</v-tooltip>
                </v-list-item>
              </template>
              <v-list-item
                v-for="page in menu.pages"
                :key="page.name"
                :title="page.name"
                :disabled="page.disabled"
                :active="selectTab === page.tab"
                @click="selectTab = page.tab"
              >
                <template v-slot:prepend>
                  <v-icon :icon="page.icon" size="16"></v-icon>
                </template>
                <v-tooltip activator="parent" location="end">{{ page.name }}</v-tooltip>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :prepend-icon="menu.icon"
              :title="menu.name"
              :disabled="menu.disabled"
              :active="selectTab === menu.tab"
              @click="selectTab = menu.tab"
            >
              <v-tooltip activator="parent" location="end">{{ menu.name }}</v-tooltip>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>

      <v-main style="background-color:rgba(255,255,255,0.5);">
        <div v-if="!showIframe" style="height: 100%;">
          <AlisonLibComponent
            ref="alisonComponent"
            :select-tab="selectTab"
            @enableTab="enableTab"
            @disableTab="disableTab"
          />
        </div>
        <AlisonIframe v-else
          :initial-params="initialParams"
          :key="iframeKey"
          @loaded="onIframeLoaded"
          ref="alisonIframe"
        />
      </v-main>
      <v-footer border>
        <v-spacer></v-spacer>
      </v-footer>
    </v-app>
</template>

<script>
import AlisonLibComponent from '../AlisonLibComponent';
import AlisonIframe from '@/components/AlisonIframe.vue';
import alisonJS from '@/services/alison_js.js';
import alisonGUI from '@/services/alison_gui.js';
import alisonLogo from '@/assets/alison-logo.png';
import * as pack from '../../package.json';

export default {
  name: 'App',
  components: {
    AlisonLibComponent,
    AlisonIframe
  },
  data() {
    return {
      alisonLogo,
      provider: 'DESKTOP',
      version: '',
      guiVersion: '',
      items: [
        { title: 'DESKTOP' },
        { title: 'SERVER' },
      ],
      showIframe: false,
      iframeKey: 0,
      initialParams: {},
      alisonGUI_version: '',
      alisonJS_version: '',
      botonera_version: '',
      rail: false,
      openedGroups: [],
      selectTab: 0,
      menuArray: [
        {
          name: 'Library',
          icon: 'mdi-bookshelf',
          pages: [
            {name: 'Initialize', icon: 'mdi-rocket-launch-outline', tab: 0, disabled: false},
            {name: 'Status', icon: 'mdi-list-status', tab: 1, disabled: false},
            {name: 'Diagnosis', icon: 'mdi-stethoscope', tab: 10, disabled: false},
          ],
        },
        {
          name: 'KeyStore',
          icon: 'mdi-key-variant',
          pages: [
            {name: 'List enabled KeyStores', icon: 'mdi-format-list-bulleted', tab: 2, disabled: true},
            {name: 'Get KeyStore information', icon: 'mdi-information-outline', tab: 3, disabled: true},
          ],
        },
        {
          name: 'Profile',
          icon: 'mdi-account-cog',
          pages: [
            {name: 'List available Profiles', icon: 'mdi-format-list-bulleted', tab: 11, disabled: true},
            {name: 'Initialize Profile', icon: 'mdi-account-plus-outline', tab: 13, disabled: true},
          ],
        },
        {
          name: 'Certificate',
          icon: 'mdi-certificate',
          pages: [
            {name: 'List all Certificates', icon: 'mdi-format-list-bulleted', tab: 7, disabled: true},
            {name: 'Generate CSR', icon: 'mdi-file-document-edit-outline', tab: 4, disabled: true},
            {name: 'Generate Certificate', icon: 'mdi-certificate-outline', tab: 5, disabled: false},
            {name: 'Install Certificate', icon: 'mdi-download-box-outline', tab: 6, disabled: true},
            {name: 'Import Certificate', icon: 'mdi-file-import-outline', tab: 12, disabled: true},
          ],
        },
        {
          name: 'Sign',
          icon: 'mdi-draw-pen',
          pages: [
            {name: 'Sign Server', icon: 'mdi-server-network', tab: 18, disabled: true},
            {name: 'Sign Desktop', icon: 'mdi-monitor', tab: 8, disabled: true},
          ],
        },
        {
          name: 'GUI',
          icon: 'mdi-monitor-dashboard',
          tab: 9,
          disabled: false
        },
        {
          name: 'GUI Playground',
          icon: 'mdi-flask-outline',
          tab: 19,
          disabled: false
        },
        {
          name: 'Alison Server',
          icon: 'mdi-server',
          pages: [
            {name: 'Config Manager', icon: 'mdi-cog-outline', tab: 14, disabled: false},
            {name: 'Create Credential', icon: 'mdi-account-key-outline', tab: 15, disabled: false},
            {name: 'Add second factors', icon: 'mdi-shield-key-outline', tab: 16, disabled: false},
            {name: 'Add certificate', icon: 'mdi-certificate-outline', tab: 17, disabled: false},
            {name: 'Pruebas', icon: 'mdi-clipboard-check-multiple-outline', tab: 20, disabled: false},
            {name: 'DigiLogix', icon: 'mdi-fingerprint', tab: 21, disabled: false},
          ],
        },
      ],
    };
  },
  created() {
    this.alisonGUI_version = alisonGUI.version;
    this.alisonJS_version = alisonJS.version;
    this.botonera_version = pack.version;

    var URLactual = window.location.search;
    var url = URLactual.replace("?", '');
    switch (url) {
      case "tab=Diagnosis":
      case "tab=diagnosis":
      case "Diagnosis":
        this.selectTab = 10
        break;
      case "tab=Detect":
      case "tab=detect":
      case "Detect":
        this.selectTab = 1
        break;
      default:
        break;
    }

    // Listen for messages from the iframe
    window.addEventListener('message', this.handleIframeMessage);
  },
  beforeUnmount() {
    // Clean up the event listener
    window.removeEventListener('message', this.handleIframeMessage);
  },
  methods: {
    disableTab(){
      this.menuArray.forEach(menu => {
          if(menu.name != 'Library' && menu.pages) {
            menu.pages.forEach(page => {
              page.disabled = true
            })
          }else{
            if(menu.name == 'Sign') {
              menu.disabled = true
            }
          }
        })
    },
    enableTab(values){
      values.forEach(tabToChange => {
        this.menuArray.forEach(menu => {
          if(menu.pages) {
            menu.pages.forEach(page => {
              if(page.name === tabToChange) page.disabled = false
            })
          }else{
            if(tabToChange == 'Sign') {
              menu.disabled = false
            }
          }
        })
      })
    },
    toggleView() {
      this.showIframe = !this.showIframe;
      if (this.showIframe) {
        // Forzar una nueva instancia del componente iframe
        this.iframeKey++;
      }
    },
    reloadIframe() {
      this.iframeKey++;
    },
    onIframeLoaded() {
      console.log('iFrame de Alison cargado');
      // Si hace falta ejecutar algo luego de cargar el iframe
    },
    handleIframeMessage(event) {
      // Manejar mensajes provenientes del iframe
      const message = event.data;
      console.log('Mensaje desde iFrame:', message);

      // Ejemplo: manejar mensaje de listo
      if (message && message.type === 'alisonIframeReady') {
        console.log('El iFrame de Alison está listo');
      }
    }
  }
};
</script>

<style scoped>
.v-navigation-drawer--rail :deep(.v-list-group__items .v-list-item) {
  padding-inline-start: 8px !important;
}
</style>
